import { FilterIcon } from '@assets/icons/index';
import { Box, Button } from '@chakra-ui/react';

import { ConditionalComponent } from '@components/functionComponent';
import { TextBold } from '@components/typography';
import { useFilter } from '@pages/AuditTrailSellOut/state/filters';

import checkFilterInformation from '@pages/AuditTrailSellOut/helpers/checkFilterInformation';

import '../styles.css';

const FilterButton = ({ isOpen, onOpen, onClose }) => {
    const filters = useFilter();

    const isOpenFilterInformation = checkFilterInformation(filters);

    const onClickFilter = () => {
        if (isOpen) onClose();
        else onOpen();
    };

    return (
        <Box className="filters__container">
            <Button
                variant="outline"
                className="filter-button"
                backgroundColor={isOpen ? 'var(--semantic-heron)' : 'white'}
                onClick={onClickFilter}
            >
                <FilterIcon />
                <TextBold className="filter-button__text no-highlight__text">Filter</TextBold>
                <ConditionalComponent statement={isOpenFilterInformation}>
                    <Box className="filter-indicator" />
                </ConditionalComponent>
            </Button>
        </Box>
    );
};

export default FilterButton;
